import type { PickerItemValidCheck } from "@9amhealth/shared";
import styled from "@emotion/styled";
import type { ZonedDateTime } from "@internationalized/date";
import type { FC } from "react";
import React, { useEffect } from "react";
import { DateWheelPicker } from "src/ui/components/DateWheelPicker/DateWheelPicker";

export const Bar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  justify-items: end;
  align-items: center;
  background: var(--color-cream-dark);
  border: 1px solid var(--color-gray-light);
  border-left: 0;
  border-right: 0;
  padding: 10px 20px;
`;

export const Button = styled.button`
  color: var(--color-charcoal);
  background: transparent;
  cursor: pointer;
  padding: 0.6rem;
  font-weight: 700;
  font-size: 14px;
`;

export const PickerFrame = styled.div`
  height: 240px;
  width: min(100vw, 488px);
  margin: 0 auto;
  overflow: hidden;
`;

interface Props {
  onRequestClose: () => void;
  onChange: (dateTime: ZonedDateTime) => void;
  title?: string;
  granularity?: "day" | "minute" | "ymd";
  initialDate?: ZonedDateTime;
  daysBack?: number;
  daysForward?: number;
  yearsBack?: number;
  yearsForward?: number;
  validateDate?: PickerItemValidCheck;
}

/*
 * Component for displaying a time picker designed for mobile devices. Own implementation of ionic inline picker.
 */
export const TimePickerSheet: FC<Props> = ({
  onRequestClose,
  onChange,
  title,
  granularity = "minute",
  initialDate,
  daysBack,
  daysForward,
  yearsBack,
  yearsForward,
  validateDate
}) => {
  useEffect(() => {
    // hide keyboard when time picker is opened
    const activeElement = document.activeElement as HTMLElement | undefined;
    activeElement?.blur();
  }, []);

  return (
    <>
      <Bar>
        <div />

        {title}

        <div>
          <Button onClick={onRequestClose}>Done</Button>
        </div>
      </Bar>

      <PickerFrame>
        <DateWheelPicker
          granularity={granularity}
          initialDate={initialDate}
          daysBack={daysBack}
          daysForward={daysForward}
          yearsBack={yearsBack}
          yearsForward={yearsForward}
          validateDate={validateDate}
          onDateSelected={(value: ZonedDateTime) => {
            onChange(value);
          }}
        />
      </PickerFrame>
    </>
  );
};
